import React from "react";

import svg from "../../assets/images/icons/EditStack/dark.svg";

export const EditStackIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Edit"}
    />
);
